module.exports = __webpack_public_path__ + "img/about.0187c6d4.png";